import { v4 as uuidV4 } from 'uuid'
export class D3Tree {
  constructor(container, options = {}) {
    if (!container) return
    const { offsetWidth, offsetHeight } = container

    const defaultOptions = {
      width: offsetWidth,
      height: offsetHeight - 20,
      marginTop: (offsetHeight - 20) / 2,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: offsetWidth / 6
    }
    // const defaultOptions = {
    //   width: 1920,
    //   height: 1080,
    //   marginTop: 500,
    //   marginRight: 10,
    //   marginBottom: 10,
    //   marginLeft: 500
    // }
    const { width, height, marginTop, marginRight, marginBottom, marginLeft } = Object.assign(defaultOptions, options)
    this.width = width
    this.height = height
    this.marginTop = marginTop
    this.marginRight = marginRight
    this.marginBottom = marginBottom
    this.marginLeft = marginLeft

    this.container = container
    // 初始比例
    this.scale = width / container.offsetWidth

    // 创建折线生成器
    this.theLine = d3.line().x(d => d.y).y(d => d.x)
  }
  create(data) {
    this.root = d3.hierarchy(data)
    this.tree = d3.tree().nodeSize([60, 200])
    // .separation((a, b) => {
    //   return (a.parent == b.parent ? 2 : 1) / a.depth;
    // })
    this.createLayout()
    this.createTreeNode()
    this.createResource()
    // 将缩放对象应用于SVG元素
    this.zoomHandler()
    this.drawTree()
  }

  drawTree() {
    this.root.x0 = this.height / 2
    this.root.y0 = 0
    this.root.descendants().forEach((d, i) => {
      d.id = uuidV4()
      d._children = d.children
      if (d.depth > 1) d.children = null
    })
    this.update(null, this.root)

    this.container.appendChild(this.svg.node())
  }

  createLayout() {
    this.svg = d3.create('svg')
      .attr('width', this.width)
      .attr('height', this.height)
      .attr('viewBox', [-this.marginLeft, -this.marginTop, this.width, this.height])
      .attr('style', 'max-width: 100%; height: auto; font: 12px sans-serif; user-select: none;')

    this.wrap = this.svg.append('g')
  }
  createTreeNode(className) {
    this.gLink = this.wrap.append('g')
      .attr('fill', 'none')
      .attr('stroke', '#ADB3C2')
      .attr('stroke-width', 1)
      .attr('stroke-dasharray', 3)
      .attr('stroke-opacity', 1)
      .attr('class', 'link-group')

    this.gNode = this.wrap.append('g')
      .attr('cursor', 'pointer')
      .attr('pointer-events', 'all')
      .attr('class', 'node-group')


    if (className) {
      this.gNode.attr('class', `node-group ${className}`)
      this.gLink.attr('class', `link-group ${className}`)
    }
  }

  update(event, source) {
    const duration = event?.altKey ? 3500 : 250
    const nodesData = this.root.descendants() //.reverse()
    const linksData = this.root.links()

    // 计算布局
    this.tree(this.root)

    let left = this.root
    let right = this.root
    this.root.eachBefore(node => {
      if (node.x < left.x) left = node
      if (node.x > right.x) right = node
    })

    const transition = this.svg.transition().duration(duration)
    // .attr('height', height)
    // .attr('viewBox', [-this.marginLeft, left.x - this.marginTop, this.width, height])
    // .tween('resize', window.ResizeObserver ? null : () => () => this.svg.dispatch('toggle'))

    d3.selectAll('.add-btn').text(d => {
      if (d.children) return '-'
      return '+'
    })
    console.log('nodesData', nodesData)
    const node = this.gNode.selectAll('.node').data(nodesData, d => d.id)
    const link = this.gLink.selectAll('.link').data(linksData, d => d.target.id)

    // 创建 Node
    this.createNode(node, source, transition, this.update.bind(this))

    // 创建 Link
    this.createLink(link, source, transition)

    // 更新位置
    this.root.eachBefore(d => {
      d.x0 = d.x
      d.y0 = d.y
    })

  }

  createNode(node, source, transition, handleFunction) {
    const nodeEnter = node.enter().append('g')
      .attr('transform', d => `translate(${source.y0},${source.x0})`)
      .attr('fill-opacity', 0)
      .attr('stroke-opacity', 0)
      .attr('class', 'node')
      .attr('id', d => `g${d.id}`)

    // 添加框
    const nodeRect = nodeEnter.append('rect')
      .attr('width', 132)
      .attr('height', 38)
      .attr('x', -66)
      .attr('y', -19)
      .attr('rx', 8)
      .attr('ry', 8)

    nodeRect.filter(d => d.depth < 2).attr('fill', d => `url(#stream_level${d.depth})`)
    nodeRect.filter(d => d.depth >= 2).attr('fill', '#fff')
      .attr('stroke-width', 1)
      .attr('stroke', '#D0D1D6')

    nodeEnter.append('text')
      .attr('y', 5)
      .attr('x', 0)
      .attr('fill', d => d.depth < 2 ? '#fff' : '#000')
      .attr('text-anchor', 'middle')
      .attr('paint-order', 'stroke')
      .attr('title', d => d.data.nodeName)
      .style('font-weight', 'bold')
      .text(d => {
        let text = d?.data?.nodeName
        if (text.length > 8) {
          text = text.slice(0, 8) + '...'
        }
        return text
      })

    // 添加title
    nodeEnter.append('title').text(d => d.data.nodeName)

    // 添加按钮
    const icon = nodeEnter
      .filter(d => d._children)
      .append('g')
      .attr('class', 'icon-text')
      .attr('opacity', 1)

    icon.append('circle')
      .attr('class', 'icon-circle')
      .attr('fill', '#B4BACA')
      .attr('r', 8)
      .attr('cx', 66)
      .attr('cy', 0)

    icon.append('text')
      .attr('class', 'add-btn')
      .attr('x', 66)
      .attr('y', 4)
      .attr('fill', '#fff')
      .attr('text-anchor', 'middle')
      .style('font-size', '14px')
      .style('font-weight', 'bold')
      .text(d => {
        if (d.children) return '-'
        return '+'
      }).on('click', (event, d) => {
        d.children = d.children ? null : d._children
        handleFunction && handleFunction(event, d)
      })

    // 添加移入动画
    const nodeUpdate = node.merge(nodeEnter)
      .transition(transition)
      .attr('transform', d => `translate(${d.y},${d.x})`)
      .attr('fill-opacity', 1)
      .attr('stroke-opacity', 1)

    // 移除动画偏移
    const height = 132
    const padding = 10
    const transitionY = height / 2 + padding
    const nodeExit = node.exit().transition(transition)
      .attr('transform', d => `translate(${source.y + transitionY},${source.x})`)
      .attr('fill-opacity', 0)
      .attr('stroke-opacity', 0)
      .remove()
  }

  twoPoints(a, b) {
    let length = Math.abs(a.y - b.y)
    let minY
    if (a.y > b.y) {
      minY = b.y
    } else {
      minY = a.y
    }
    const midPointY = length / 2 + minY
    return {
      az: { x: a.x, y: midPointY },
      bz: { x: b.x, y: midPointY }
    }
  }

  getPathData(sp, ep) {
    // sp = { x: sp.y, y: sp.x }
    // ep = { x: ep.y, y: ep.x }
    sp = { x: sp.x, y: sp.y }
    ep = { x: ep.x, y: ep.y }
    // 计算两个直角折点的坐标
    const { az: midPoint1, bz: midPoint2 } = this.twoPoints(sp, ep)
    return [sp, midPoint1, midPoint2, ep]
  }

  createLine(d) {
    const height = 132
    const padding = 10
    const transitionY = height / 2 + padding
    const sp = { x: d.source.x, y: d.source.y + transitionY }
    const ep = { x: d.target.x, y: d.target.y - transitionY }
    const pathData = this.getPathData(sp, ep)
    return this.theLine(pathData)
  }

  createLink(link, source, transition) {

    // Enter any new links at the parent's previous position.
    const linkEnter = link.enter().append('path')
      .attr('d', d => {
        const o = { x: source.x0, y: source.y0 }
        return this.createLine({ source: o, target: o })
      })

    // Transition links to their new position.
    link.merge(linkEnter).transition(transition)
      .attr('d', (d) => {
        return this.createLine(d)
      })
      .attr('stroke-opacity', 1)
      .attr('fill-opacity', 1)
      .attr('class', 'link')
      .transition()
      .attr('marker-end', 'url(#marker_arrow)')


    // Transition exiting nodes to the parent's new position.
    link.exit().transition(transition)
      .attr('d', (d) => {
        const o = { x: source.x, y: source.y }
        return this.createLine({ source: o, target: o })
      })
      .attr('marker-end', 'none')
      .attr('stroke-opacity', 0)
      .attr('fill-opacity', 0)
      .remove()
  }

  createResource() {
    // 复用集合
    const defs = this.svg.append('defs')
    defs.append('pattern')
      .attr('id', 'stream_level0')
      .attr('width', '100%')
      .attr('height', '100%')
      .attr('patternContentUnits', 'objectBoundingBox')
      .append('image')
      .attr('href', '/static/image/d3tree/cylbg01.svg')
      .attr('width', '1')
      .attr('height', '1')
      .attr('preserveAspectRatio', 'none')

    defs.append('pattern')
      .attr('id', 'stream_level1')
      .attr('width', '100%')
      .attr('height', '100%')
      .attr('patternContentUnits', 'objectBoundingBox')
      .append('image')
      .attr('href', '/static/image/d3tree/cylbg02.svg')
      .attr('width', '1')
      .attr('height', '1')
      .attr('preserveAspectRatio', 'none')

    defs.append('pattern')
      .attr('id', 'stream-bottom')
      .attr('width', '100%')
      .attr('height', '100%')
      .attr('patternContentUnits', 'objectBoundingBox')
      .append('image')
      .attr('href', '/static/image/d3tree/stream-bottom.svg')
      .attr('width', '1')
      .attr('height', '1')
      .attr('preserveAspectRatio', 'none')

    defs.append('pattern')
      .attr('id', 'stream-center')
      .attr('width', '100%')
      .attr('height', '100%')
      .attr('patternContentUnits', 'objectBoundingBox')
      .append('image')
      .attr('href', '/static/image/d3tree/stream-center.svg')
      .attr('width', '1')
      .attr('height', '1')
      .attr('preserveAspectRatio', 'none')

    defs.append('pattern')
      .attr('id', 'stream-top')
      .attr('width', '100%')
      .attr('height', '100%')
      .attr('patternContentUnits', 'objectBoundingBox')
      .append('image')
      .attr('href', '/static/image/d3tree/stream-top.svg')
      .attr('width', '1')
      .attr('height', '1')
      .attr('preserveAspectRatio', 'none')

    defs.append('marker')
      .attr('id', 'marker_arrow')
      .attr('markerHeight', '8')
      .attr('markerWidth', '8')
      .attr('markerUnits', 'strokeWidth')
      .attr('orient', 'auto')
      .attr('refX', '0')
      .attr('refY', '0')
      .attr('viewBox', '-8 -8 16 16')
      .append('path')
      .attr('fill', '#ADB3C2')
      .attr('d', 'M 0,0 m -8,-8 L 8,0 L -8,8 Z')



    defs.append('marker')
      .attr('id', 'marker_arrow-0')
      .attr('markerHeight', '8')
      .attr('markerWidth', '8')
      .attr('markerUnits', 'strokeWidth')
      .attr('orient', 'auto')
      .attr('refX', '0')
      .attr('refY', '0')
      .attr('viewBox', '-8 -8 16 16')
      .append('path')
      .attr('fill', '#186bfc')
      .attr('d', 'M 0,0 m -8,-8 L 8,0 L -8,8 Z')

    defs.append('marker')
      .attr('id', 'marker_arrow-1')
      .attr('markerHeight', '8')
      .attr('markerWidth', '8')
      .attr('markerUnits', 'strokeWidth')
      .attr('orient', 'auto')
      .attr('refX', '0')
      .attr('refY', '0')
      .attr('viewBox', '-8 -8 16 16')
      .append('path')
      .attr('fill', '#5bc330')
      .attr('d', 'M 0,0 m -8,-8 L 8,0 L -8,8 Z')

    defs.append('marker')
      .attr('id', 'marker_arrow-2')
      .attr('markerHeight', '8')
      .attr('markerWidth', '8')
      .attr('markerUnits', 'strokeWidth')
      .attr('orient', 'auto')
      .attr('refX', '0')
      .attr('refY', '0')
      .attr('viewBox', '-8 -8 16 16')
      .append('path')
      .attr('fill', '#ff6c52')
      .attr('d', 'M 0,0 m -8,-8 L 8,0 L -8,8 Z')
  }

  zoomHandler(r) {
    const rang = r || [0.5, 10]

    this.wrap.attr('transform', `translate(${0},${0}) scale(${this.scale})`)

    // 创建一个缩放对象
    const zoom = d3.zoom()
      .scaleExtent(rang) // 设置缩放范围
      .on('zoom', current => {
        const { transform } = current
        if (isNaN(transform.x)) return
        this.wrap.attr('transform', `translate(${transform.x},${transform.y}) scale(${transform.k * this.scale})`)
      })
    // 将缩放对象应用于SVG元素
    this.svg.call(zoom)
      .on('dblclick.zoom', event => event.preventDefault())

    return zoom
  }
}

export class StreamsTree extends D3Tree {
  constructor(container, options) {
    super(container, options)
    // 初始比例
    this.scale = 1 //this.width / 1920
    this.marginLeft = 100

  }
  create(data) {
    if (!data) return
    if (!(data instanceof Array)) return
    this.tree = d3.tree().nodeSize([60, 200])

    this.createLayout()
    this.createResource()

    const w = this.container.offsetWidth
    // const percent = this.width / w
    // const percent = this.scale
    this.maxTranslateX = w / 3 // * percent
    console.log(this.maxTranslateX)

    for (let index = 0; index < data.length; index++) {
      const element = data[index]
      element[0] && this.createTree(element[0], 'stream' + index, index)
    }
    this.zoomHandler([1, 1])

    this.container.appendChild(this.svg.node())
  }
  createTree(data, className, index) {
    this.root = d3.hierarchy(data)
    this.root.descendants().forEach((d, i) => {
      d.id = uuidV4()
      d._children = d.children
      if (d.depth > 1) d.children = null
    })
    // Compute the new tree layout.
    this.tree(this.root)

    const nodesData = this.root.descendants() //.reverse()
    const linksData = this.root.links()

    this.createTreeNode(className)

    const node = this.gNode.selectAll(`.${className}`).data(nodesData, d => d.id)

    const link = this.gLink.selectAll(`.${className}`).data(linksData, d => d.target.id)

    // const transition = this.svg.transition().duration(250)

    // 创建 Node
    this.createNode(node, index)

    // 创建 Link
    this.createLink(link, index)

    this.gNode.attr('transform', d => `translate(${index * this.maxTranslateX},0)`)
    this.gLink.attr('transform', d => `translate(${index * this.maxTranslateX},0)`)
  }
  createNode(node, index) {

    const nodeEnter = node.enter().append('g')
      .attr('transform', d => `translate(${d.y},${d.x})`)
      .attr('fill-opacity', 0)
      .attr('stroke-opacity', 0)
      .attr('class', 'node')
      .attr('id', d => `g${d.id}`)

    // 添加框
    const nodeRect = nodeEnter.append('rect')
      .attr('width', 132)
      .attr('height', 38)
      .attr('x', -66)
      .attr('y', -19)
      .attr('rx', 8)
      .attr('ry', 8)

    nodeRect.filter(d => d.depth < 1).attr('fill', d => `url(#stream-${['top', 'center', 'bottom'][index]})`)
    nodeRect.filter(d => d.depth >= 1).attr('fill', '#fff')
      .attr('stroke-width', 1)
      .attr('stroke', '#D0D1D6')


    nodeEnter.append('text')
      .attr('y', 5)
      .attr('x', 0)
      .attr('fill', d => d.depth < 1 ? '#fff' : '#000')
      .attr('text-anchor', 'middle')
      .attr('paint-order', 'stroke')
      .attr('title', d => d.data.nodeName)
      .style('font-weight', 'bold')
      .text(d => {
        let text = d?.data?.nodeName
        if (text.length > 8) {
          text = text.slice(0, 8) + '...'
        }
        return text
      })

    // 添加title
    nodeEnter.append('title').text(d => d.data.nodeName)

    const nodeUpdate = node.merge(nodeEnter)
      .transition()
      .attr('transform', d => `translate(${d.y},${d.x})`)
      .attr('fill-opacity', 1)
      .attr('stroke-opacity', 1)
  }
  createLink(link, index) {
    const linkEnter = link.enter().append('path')

    link.merge(linkEnter).transition()
      .attr('d', d => this.createLine(d))
      .attr('stroke', ['#186bfc', '#5bc330', '#ff6c52'][index])
      .attr('fill-opacity', 1)
      .attr('fill-opacity', 1)
      .attr('class', 'link')
      .transition()
      .attr('marker-end', `url(#marker_arrow-${index})`)
  }
}


export class D3Path {
  constructor(container, options = {}) {
    if (!container) return

    const { offsetWidth, offsetHeight } = container
    this.width = offsetWidth
    this.height = offsetHeight

    this.container = container
    container.style.position = 'relative'

    // 创建折线生成器
    this.theLine = d3.line().x(d => d.x).y(d => d.y)
    this.createLayout()
    this.createResource()
    // this.zoomHandler([1,1])
    this.container.appendChild(this.svg.node())

  }
  create(paths) {
    if (!paths) return
    this.paths = paths

    // paths
    this.update()
  }

  update() {
    for (let index = 0; index < this.paths.length; index++) {
      const { start, end } = this.paths[index]
      this.createLink(this.gLink, [{
        start: this.getDomPosition(start, true),
        end: this.getDomPosition(end)
      }])
    }
  }

  createLink(link, paths) {
    link.append('path')
      .data(paths)
      .attr('d', (d) => this.createLine(d))
      .attr('stroke-opacity', 1)
      .attr('fill-opacity', 1)
      .attr('class', 'link')
      .transition()
      .attr('marker-end', 'url(#marker_arrow-9)')
  }

  createLayout() {
    this.svg = d3.create('svg')
      .attr('width', this.width)
      .attr('height', this.height)
      .attr('viewBox', [0, 0, this.width, this.height])
      .attr('style', 'width: 100%;;font:12px sans-serif; user-select: none;position: absolute;top: 0;left: 0;z-index: 1;')

    this.wrap = this.svg.append('g')

    this.gLink = this.wrap.append('g')
      .attr('fill', 'none')
      .attr('stroke', '#ADB3C2')
      .attr('stroke-width', 1)
      .attr('stroke-dasharray', 4)
      .attr('stroke-opacity', 1)
      .attr('class', 'link-group')
  }

  getDomPosition(dom, isStart) {
    let x = 0
    let y = 0
    const p = this.findParent(dom, this.container)

    p.forEach(e => {
      const { offsetLeft, offsetWidth, offsetTop, offsetHeight } = e
      x += (offsetLeft + (dom == e ? offsetWidth : 0))
      y += (offsetTop + (dom == e ? offsetHeight / 2 : 0))
    })

    if (!isStart) {
      x = p[p.length - 1].offsetLeft - 10
    }

    return { x, y }
  }

  findParent(dom, target) {
    if (!dom) return
    let domArr = []
    function fined(dom, target) {
      const { offsetParent } = dom;
      domArr.push(dom);
      if (offsetParent && offsetParent !== target) {
        fined(offsetParent, target);
      }
    }
    fined(dom, target)
    return domArr

  }

  twoPoints(a, b) {
    let length = Math.abs(a.x - b.x)
    let minX
    if (a.x > b.x) {
      minX = b.x
    } else {
      minX = a.x
    }
    const midPointX = length / 2 + minX
    return {
      az: { x: midPointX, y: a.y },
      bz: { x: midPointX, y: b.y }
    }
  }

  getPathData(sp, ep) {
    // 计算两个直角折点的坐标
    const { az: midPoint1, bz: midPoint2 } = this.twoPoints(sp, ep)
    return [sp, midPoint1, midPoint2, ep]
  }

  createLine(d) {
    const height = 132
    const padding = 10
    const transitionY = height / 2 + padding
    const sp = { x: d.start.x, y: d.start.y }
    const ep = { x: d.end.x, y: d.end.y }
    const pathData = this.getPathData(sp, ep)
    return this.theLine(pathData)
  }

  createResource() {
    // 复用集合
    const defs = this.svg.append('defs')

    defs.append('marker')
      .attr('id', 'marker_arrow-9')
      .attr('markerHeight', '8')
      .attr('markerWidth', '8')
      .attr('markerUnits', 'strokeWidth')
      .attr('orient', 'auto')
      .attr('refX', '0')
      .attr('refY', '0')
      .attr('viewBox', '-8 -8 16 16')
      .append('path')
      .attr('fill', '#ADB3C2')
      .attr('d', 'M 0,0 m -8,-8 L 8,0 L -8,8 Z')



    defs.append('marker')
      .attr('id', 'marker_arrow-0')
      .attr('markerHeight', '8')
      .attr('markerWidth', '8')
      .attr('markerUnits', 'strokeWidth')
      .attr('orient', 'auto')
      .attr('refX', '0')
      .attr('refY', '0')
      .attr('viewBox', '-8 -8 16 16')
      .append('path')
      .attr('fill', '#186bfc')
      .attr('d', 'M 0,0 m -8,-8 L 8,0 L -8,8 Z')

    defs.append('marker')
      .attr('id', 'marker_arrow-1')
      .attr('markerHeight', '8')
      .attr('markerWidth', '8')
      .attr('markerUnits', 'strokeWidth')
      .attr('orient', 'auto')
      .attr('refX', '0')
      .attr('refY', '0')
      .attr('viewBox', '-8 -8 16 16')
      .append('path')
      .attr('fill', '#5bc330')
      .attr('d', 'M 0,0 m -8,-8 L 8,0 L -8,8 Z')

    defs.append('marker')
      .attr('id', 'marker_arrow-2')
      .attr('markerHeight', '8')
      .attr('markerWidth', '8')
      .attr('markerUnits', 'strokeWidth')
      .attr('orient', 'auto')
      .attr('refX', '0')
      .attr('refY', '0')
      .attr('viewBox', '-8 -8 16 16')
      .append('path')
      .attr('fill', '#ff6c52')
      .attr('d', 'M 0,0 m -8,-8 L 8,0 L -8,8 Z')
  }
}



